<template>
  <div class="app">
    <!-- 导航条 -->
    <div class="navigation-container">
        <Header class="navigation-box"></Header>    
        <div class="shadow-bar" :style="{ opacity : showBackground ? '1':'0'}"></div>
    </div>
    <Sidebar/>
    <router-view></router-view>
    <!-- 底部 -->
    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Bottom from './components/Bottom.vue'
import Sidebar from './components/Sidebar.vue'

export default {
  name: 'App',
  components:{
    Header,Bottom,Sidebar
  },
  data(){
    return{
      showBackground:false
    }
  },
  methods:{
    handleScroll() {  //处理导航条背景，同时处理返回顶部的按钮

        // 获取页面滚动的垂直距离。这里使用了逻辑或操作符来确保在所有浏览器中都能正确获取到scrollTop的值。  
        // window.pageYOffset是标准属性，但在某些老旧的浏览器中可能不支持，因此提供了备选方案。 
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;  
            
        // 假设当滚动超过64px时显示背景  
        if (scrollTop > 66) {  
            this.showBackground = true;  
        } else {  
            this.showBackground = false;  
        }  
    }
  },
  mounted() {  
      // 向window对象添加滚动事件监听器，当页面滚动时，会调用handleScroll方法。    
      window.addEventListener('scroll', this.handleScroll);  
  },  
  beforeDestroy() {  
        // 移除之前添加到window对象的滚动事件监听器，防止内存泄漏。  
        // 同样地，这里直接使用this.handleScroll作为监听器的引用是可行的，因为Vue的methods方法会绑定到组件实例上。      
      window.removeEventListener('scroll', this.handleScroll);  
  },
}
</script>

<style <style lang="scss" scoped>
#app{
  width: 100%;
  height: 100%;
  position: absolute;
  margin:0;
  padding: 0;
  background-color: #000000;
  z-index: 1;
}
/* 单行显示 溢出隐藏 */
.hidden_line {
  /* 强制不换行 */
  white-space: nowrap;
  /* 文本溢出隐藏 */
  overflow: hidden;
  /* 省略号 */
  text-overflow: ellipsis;
}
.navigation-container{
    position: fixed;
    z-index: 100;
    .navigation-box{
        position: fixed;
        height: 64px;
        padding: 0;
        margin: 0;
        z-index: 100;
    }    
    .shadow-bar{
        position: fixed;
        width: 100%;
        height: 64px;
        background: #00000040;
        // filter: blur(4px);
        backdrop-filter:blur(10px);
        z-index: 99;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
}
</style>
